import React, { useCallback } from 'react';

import { cn } from 'common/style/utils';
import ActivityTabContent from 'common/subdomain/admin/v2/AdminV2IdeaSheet/InternalView/Activity/ActivityTabContent';
import InsightList from 'common/subdomain/admin/v2/AdminV2IdeaSheet/InternalView/Insights/InsightList';
import Tabs from 'common/uiV3/Tabs';

import type { Idea } from 'common/api/endpoints/idea';
import type { View } from 'common/api/endpoints/view';

export enum InternalViewTabName {
  Insights = 'insights',
  Activity = 'activity',
}

type IdeaTabsProps = {
  idea: Idea;
  selectedView?: View | null;
  initialTab?: string;
};

const IdeaTabs = ({ idea, selectedView, initialTab }: IdeaTabsProps) => {
  const getDefaultTab = useCallback(() => {
    if (initialTab === InternalViewTabName.Activity) {
      return InternalViewTabName.Activity;
    }
    return InternalViewTabName.Insights;
  }, [initialTab]);

  return (
    <Tabs defaultValue={getDefaultTab()} className="flex flex-col flex-1">
      <Tabs.List className="px-5">
        <Tabs.Trigger value={InternalViewTabName.Insights}>Insights</Tabs.Trigger>
        <Tabs.Trigger value={InternalViewTabName.Activity}>Activity</Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content value={InternalViewTabName.Insights}>
        <InsightList idea={idea} selectedView={selectedView} />
      </Tabs.Content>
      <Tabs.Content
        value={InternalViewTabName.Activity}
        className={cn(
          'data-[state=active]:flex',
          'data-[state=active]:flex-col',
          'data-[state=active]:flex-1',
        )}>
        <ActivityTabContent idea={idea} />
      </Tabs.Content>
    </Tabs>
  );
};

export default IdeaTabs;
